<button class="mat-button" mat-raised-button [disabled]="disabled" (click)="click($event)">{{ name }}</button>